module.exports = __webpack_public_path__ + "static/img/zw.6ac3949a.svg";